<script>
	import BulbOff from '../../../assets/bulb_off.svelte';
	import BulbOn from '../../../assets/bulb_on.svelte';
	export let height;
	export let toggleTips = () => {};
	export let onMouseDown = () => {};
	export let isTipsOn = false;
</script>

<div
	class="tips-btn"
	on:mousedown={onMouseDown}
	style={`height:${height}px;width:${height}px`}
	on:click={toggleTips}
>
	{#if isTipsOn}
		<BulbOn />
	{:else}
		<BulbOff />
	{/if}
</div>

<style>
	div {
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
